import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { FULL_HD, HD, KEYBOARD_OFFSET_Y, KEYBOARD_OFFSET_X, KEYBOARD_WIDTH } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../tornado/utils/sizes';
import { OFFSET as SEARCH_FIELD_OFFSET } from './searchField/searchField.style';
import { TRANSPARENT } from '../tornado/utils/colors';

export const defaultContext = makeDefaultStylingContext();

export const BACKGROUND_COLOR = makeThemeColor(TERTIARY);

export const getBlockOffset = screenSize => KEYBOARD_OFFSET_X[screenSize] + KEYBOARD_WIDTH[screenSize];

export const OVERLAY_HEIGHT = {
  [HD]: 75,
  [FULL_HD]: 75,
};

export const SEARCH_RESULT_OFFSET_Y = {
  [HD]: 140,
  [FULL_HD]: 200,
};

export const SEARCH_RESULT_OFFSET_X = {
  [HD]: 510,
  [FULL_HD]: 710,
};

export const OVERLAY_OFFSET = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const barOffset = KEYBOARD_OFFSET_Y[screenSize] - SEARCH_FIELD_OFFSET[screenSize];
  const w = SCREEN_WIDTH[screenSize];
  const h = SCREEN_HEIGHT[screenSize];

  return {
    forceZIndexContext: true,
    w,
    h,
    Background: {
      w,
      h,
      color: BACKGROUND_COLOR[colorMode],
    },
    SearchField: {
      zIndex: 4,
    },
    Keyboard: {
      zIndex: 3,
    },
    SearchHistory: {
      zIndex: 3,
    },
    Strip: {
      zIndex: 2,
      w,
      h: barOffset,
      color: BACKGROUND_COLOR[colorMode],
    },
    Overlay: {
      zIndex: 2,
      w,
      h: OVERLAY_HEIGHT[screenSize],
      y: barOffset - OVERLAY_OFFSET[screenSize],
      colorTop: BACKGROUND_COLOR[colorMode],
      colorBottom: TRANSPARENT,
    },
    SearchResultBlock: {
      zIndex: 1,
      x: SEARCH_RESULT_OFFSET_X[screenSize],
      y: SEARCH_RESULT_OFFSET_Y[screenSize],
      w: w - SEARCH_RESULT_OFFSET_X[screenSize],
      h: h - SEARCH_RESULT_OFFSET_Y[screenSize],
      clipping: true,
    },
  };
};
